import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  colors: {
    purple: {
      50: '#f5ebf0',
      100: '#e0ccda',
      200: '#cbabc4',
      300: '#b58bae',
      400: '#a06b98',
      500: '#942F67', // Orchid Rose
      600: '#7a2554',
      700: '#611e43',
      800: '#491733',
      900: '#300f22',
    },
    blue: {
      50: '#f5f4f9',
      100: '#e1def0',
      200: '#ccc8e6',
      300: '#b8b2dd',
      400: '#A9A4C9', // Digital Violet 400 (lighter)
      500: '#8c85b8', // 500 for main
      600: '#7169a3',
      700: '#565080',
      800: '#3b375c',
      900: '#211e38',
    },
    orange: {
      50: '#fbf3ef',
      100: '#f2dec5',
      200: '#eac89a',
      300: '#e2b36f',
      400: '#D08F6B', // Fade Citrus
      500: '#c2764f',
      600: '#a15d3a',
      700: '#7f4526',
      800: '#5e3016',
      900: '#3e1b07',
    },
    green: {
      50: '#f3f5f1',
      100: '#dde3d8',
      200: '#c7cfbf',
      300: '#b1bba5',
      400: '#9ba88b',
      500: '#86947A', // Jade
      600: '#69765e',
      700: '#4e5845',
      800: '#343b2e',
      900: '#1a1d17',
    },
    red: {
      50: '#f4eaeb',
      100: '#dfc8c9',
      200: '#caa5a7',
      300: '#b58385',
      400: '#a06163',
      500: '#85504E', // Astro Dust
      600: '#683e3d',
      700: '#4b2d2c',
      800: '#2e1c1c',
      900: '#120b0b',
    },
    teal: {
      // Just map teal to Digital Violet for consistency if it's used
      50: '#f5f4f9',
      100: '#e1def0',
      200: '#ccc8e6',
      300: '#b8b2dd',
      400: '#A9A4C9',
      500: '#8c85b8',
      600: '#7169a3',
      700: '#565080',
      800: '#3b375c',
      900: '#211e38',
    }
  },
  fonts: {
    heading: "'Outfit', sans-serif",
    body: "'Plus Jakarta Sans', 'Inter', sans-serif",
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: 'xl',
      }
    }
  }
});

export default theme;
